export const formatAudioDuration = (duration: number) => {
  const hoursValue = Math.floor(duration / 3600000);
  const minutesValue = Math.floor(duration / 60000) - hoursValue * 60;
  const secondsValue =
    Math.floor(duration / 1000) -
    hoursValue * 3600 -
    minutesValue * 60;

  let formattedResult = '';

  if (hoursValue > 0) {
    console.log('hoursValue', hoursValue);
    formattedResult += `${hoursValue}h`;
  }
  if (minutesValue > 0) {
    formattedResult += `${minutesValue}m`;
  }

  formattedResult += `${secondsValue}s`;

  return formattedResult;
};

export const formatBytes = (bytes: number) => {
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  }
  if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};
